<template>
  <div>
    <h3
      style="align-items: center; text-align: center; font-family: 'Times New Roman', Times, serif;"
    >
      <b>Tekshiruvlar xulosasi</b>
    </h3>
    <label class="multiline-text"
      ><b>EKG</b> {{ selectShablonJson.value1 }}</label
    >
    <br />
    <label class="multiline-text"
      ><b>EXOKG</b> {{ selectShablonJson.value2 }}</label
    >
    <br />
    <label class="multiline-text"
      ><b>BTSA UTT</b> {{ selectShablonJson.value3 }}</label
    >
    <br />
    <label class="multiline-text"
      ><b>Dastlabki tashxis:</b> {{ selectShablonJson.value4 }}</label
    >
    <br />
    <label class="multiline-text"
      ><b>Hamroh:</b> {{ selectShablonJson.value5 }}</label
    >
    <br />
    <label class="multiline-text"
      ><b>Asorati:</b> {{ selectShablonJson.value6 }}</label
    >
    <h3
      style="align-items: center; text-align: center; font-family: 'Times New Roman', Times, serif;"
    >
      <b>Davoni va tekshiruvni asoslash</b>
    </h3>
    <label>{{ selectShablonJson.value7 }}</label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectShablonJson: {},
      data: {}
    };
  },
  created: function() {
    this.data = JSON.parse(localStorage.getItem("xulosa"));
    this.selectShablonJson = JSON.parse(this.data.value.toString());
  },
  mounted() {
    localStorage.removeItem("xulosa");
    window.print();
    setTimeout(() => {
      //   this.$router.push({ path: "/user" });
      window.close();
    }, 3000);
  }
};
</script>

<style lang="scss">
.multiline-text {
  white-space: pre-line;
}
label {
  font-family: "Times New Roman", Times, serif;
  // margin-top: 5px;
  font-size: 14pt;
  line-height: 14pt;
  // font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
}
.display-flex {
  display: flex;
}
</style>
